// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"475dc44f","134":"73e50cbf","415":"475dc44f","429":"475dc44f","569":"475dc44f","734":"f149f751","973":"35f60e53"}[chunkId] + ".chunk.css";
};